import spanThumbnail from '../Images/projSpan.JPG';
import portThumbnail from '../Images/projPortfolio.JPG';
export const ProjectData = [
  {
    imgSrc: spanThumbnail,
    title: 'Spanish Guesser',
    description:
      'Dynamic React app to practise basic levels of the Spanish language. Contains two levels of difficulty tallying score on right answers. Robust backend made using MongoDB and Node.Js, as well as utilizing multiple Restful APIs for things like determining correctness in hard mode.',
    technology: 'React React-Hooks Node.JS MongoDB Restful-APIs HTML CSS',
    url: 'https://spanishguesser.com/Guess',
    gitUrl: 'https://github.com/1Jama/guess-the-word',
  },
  {
    imgSrc: portThumbnail,
    title: 'Personal Portfolio Website',
    description:
      'Website where I host my projects as well as have information listed about myself. Built using React, Bootstrap, Tailwind.',
    technology: 'React React-Hooks Bootstrap Tailwind HTML CSS',
    url: 'https://jamafarah.com/',
    gitUrl: 'https://github.com/1Jama/Personal-Site',
  },
];
